import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { styled, useMediaQuery, useTheme } from "@mui/system";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import CustomFooter from "../../UiComponent/CustomFooter";
import Loader from "../../UiComponent/Loader";
import NewHeader from "../../UiComponent/NewHeader";
import { defaultLabelColors } from "../../utils/constants";
import { handleLocalize, useResponsiveValue1024 } from "../../utils/helper";
// import { AddIcon } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import MobileResponsive from "../LandingPage/MobileResponsive";
// interface InstagramPost {
//   id: string;
//   media_url: string;
//   caption: string;
// }
function FAQ(props: any) {
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      activity: false,
      page: 1,
      expanded_1: false,
      expanded_2: false,
      expanded_3: false,
      expanded_4: false,
      expanded_5: false,
      expanded_6: false,
      expanded_7: false,
    }
  );
  const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));

  const CustomToggleButton = styled(ToggleButton)({
    // padding: "0px 0px",
    backgroundColor: "white",
    border: "1px solid #E0E0E0",
    marginLeft: "-1px",
    borderRadius: "12px !important",
    borderLeft: "1px solid #E0E0E0 !important",
    borderTopLeftRadius: "12px !important",
    borderBottomLeftRadius: "12px !important",
    color: "#6F6C90",
    width: screen_1024 ? 176: 171,
    padding:"0px 0px",
    height: screen_1024 ?"48px":"44px",
    textTransform: "none", // Prevent capitalization
    fontFamily: "montserrat-Regular",
    "&.Mui-selected": {
      color: "white",
      border: "1px solid #E0E0E0",
      backgroundColor: defaultLabelColors?.main_orange_new,
      fontFamily: "montserrat-SemiBold",

    },
    "& .MuiToggleButtonGroup-lastButton, & .MuiToggleButtonGroup-middleButton":
      {
        marginLeft: "-1px",
        borderLeft: "1px solid #E0E0E0 !important",
        borderTopLeftRadius: "12px",
        borderBottomLeftRadius: "12px",
      },
  });
  const screen_600 = useMediaQuery(theme.breakpoints.up(601));

  const [selectedCategory, setSelectedCategory] = useState<string | null>(
    "Genéral"
  );

  const handleCategoryChange = (
    _event: React.MouseEvent<HTMLElement>,
    newCategory: string | null
  ) => {
    if (newCategory === null) {
      return;
    }
    setSelectedCategory(newCategory);
  };
  const handleExpanded = (state_name: any) => {
    try {
      setState({ [state_name]: !state?.[state_name] });
    } catch (error) {}
  };

  return (
    <>
      <Loader loading={state?.activity} />

      <Helmet>
        <title>FAQ</title>
        <link rel="canonical" href="https://www.frank.fr/faq" />
        <meta
          name="description"
          content="Découvrez nos articles et conseils sur la livraison collaborative, des témoignages de la communauté Frank, et des astuces pour optimiser vos envois."
        />
      </Helmet>
      <div
        className="web-screen"
        style={{ background: defaultLabelColors?.main_background_new }}
      >
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >

          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader />
            <div
              style={{
                background: defaultLabelColors?.main_background_new,
                padding: useResponsiveValue1024("80px 50px", "80px 0px"),

                marginTop: screen_1024 ? 80:0,
              }}
            >
              <div className="display-flex">
                <h1
                  style={{
                    fontFamily: "montserrat-Bold",
                    fontSize: useResponsiveValue1024("40px", "30px"),
                    marginBottom:screen_1024 ?26:53
                  }}
                >
                  Frequently Asked Questions
                </h1>
              </div>
              <div className="display-flex">
                <ToggleButtonGroup
                  value={selectedCategory}
                  exclusive
                  onChange={handleCategoryChange}
                  aria-label="FAQ filter"
                  style={{
                    marginBottom: screen_1024 ? "20px" :"40px",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  {["Genéral", "Envoyer", "Transporter"]
                    ?.slice?.(0, 6)
                    ?.map((item: any) => (
                      <CustomToggleButton
                        key={""}
                        value={handleLocalize({
                          en: item,
                          fr: item,
                        })}
                        // style={{ borderRadius: "2px", padding: "8px 16px" }}
                      >
                        {handleLocalize({
                          en: item,
                          fr: item,
                        })}
                      </CustomToggleButton>
                    ))}
                </ToggleButtonGroup>
              </div>
              <div
                className="display-flex"
                style={{
                  background: "#fff",
                  borderRadius: 24,
                  padding: "60px",
                }}
              >
                {selectedCategory === "Genéral" ? (
                  <Grid
                    container
                    spacing={2}
                    style={{
                      padding: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      xs={12}
                      item
                      className="display-flex"
                      style={{
                        flexDirection: "column",
                        padding: "10px",
                        borderRadius: "18px",
                        gap: 20,
                      }}
                    >
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_1}
                        onChange={() => handleExpanded("genral_expanded_1")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_1 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                            }}
                          >
                            Comment fonctionne la livraison collaborative ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          Grâce à notre plateforme, un particulier peut envoyer
                          un colis qui sera livré par un autre particulier lors
                          d’un de ses trajets personnels. Au cœur de notre
                          activité, la livraison collaborative nous permet de
                          créer une communauté d’entraide en garantissant un
                          service d’envoi peu coûteux et écologique.
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_2}
                        onChange={() => handleExpanded("genral_expanded_2")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_2 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Comment fonctionne la livraison professionnelle avec
                            Frank ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            {" "}
                            Nous couvrons l’envoi du premier au dernier
                            kilomètre et stockons vos colis dans notre entrepôt
                            en Île-de-France. En fonction de vos besoins, nous
                            proposons plusieurs modes de livraison
                            professionnelle :
                          </p>

                          <p>
                            {" "}
                            • Pick & Pack : récupération des colis à votre
                            adresse, préparation des colis, packaging d’envoi{" "}
                          </p>
                          <p>
                            {" "}
                            • Livraison totale : nous nous occupons de tout, de
                            la récupération des colis jusqu’à leur dépôt chez le
                            client final{" "}
                          </p>
                          <p>
                            {" "}
                            • Stockage : nous stockons vos colis dans notre
                            entrepôt en Île-de-France, avant leur retrait
                          </p>

                          <p>
                            Pour plus d’informations, vous pouvez nous contacter
                            en envoyant un mail à l’adresse :{" "}
                            <a href="mailto:hello@frankme.com">
                              hello@frankme.com
                            </a>
                            .
                          </p>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          width: "100%",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_3}
                        onChange={() => handleExpanded("genral_expanded_3")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_3 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Puis-je gagner de l’argent avec Frank ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "100%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Vous êtes transporteur ? En voiture, en train, en
                            trottinette, en péniche ou à pied, quel que soit le
                            mode de transport, vous gagnez de l’argent
                            !ㅤㅤㅤㅤㅤㅤ
                          </p>

                          <p>
                            Vous envoyez un colis avec Frank ? Vous ne gagnez
                            pas d’argent, mais vous en économisez à coup sûr !
                          </p>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_4}
                        onChange={() => handleExpanded("genral_expanded_4")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_4 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,

                              padding: "20px 0px",
                            }}
                          >
                            Comment fonctionne l’assurance des colis ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          Tout envoi de colis via Frank est assuré à une hauteur
                          de 100 €. Pour vos colis les plus précieux, vous
                          pouvez souscrire à une assurance supplémentaire
                          (HISCOX).
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_5}
                        onChange={() => handleExpanded("genral_expanded_5")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_5 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,

                              padding: "20px 0px",
                            }}
                          >
                            Comment devenir transporteur ?
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "100%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            {" "}
                            Pour devenir transporteur à nos côtés, rien de plus
                            simple : Pour devenir transporteur à nos côtés, rien
                            de plus simple : Pour devenir transporteur à nos
                            côtés, rien de plus simple :
                          </p>

                          <p>
                            {" "}
                            • Vous créez un compte sur le site ou l’application
                            de Frank ;{" "}
                          </p>
                          <p>
                            {" "}
                            • Vous checkez les annonces à côté de vous, ou sur
                            vos trajets ;{" "}
                          </p>
                          <p> • Vous acceptez une offre ;</p>
                          <p>
                            {" "}
                            • Vous remettez le colis au destinataire, qui vous
                            remet un code pour valider la livraison ;{" "}
                          </p>
                          <p>
                            {" "}
                            • Vous recevez le montant de la livraison sur votre
                            porte-monnaie une fois que vous avez renseigné le
                            code.{" "}
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_6}
                        onChange={() => handleExpanded("genral_expanded_6")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_6 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,

                              padding: "20px 0px",
                            }}
                          >
                            En tant que transporteur, comment transférer
                            l’argent de mon porte-monnaie sur mon compte
                            bancaire ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          Sur l’application Frank, il y a un espace
                          porte-monnaie, où vous trouverez le montant total de
                          vos gains. Il suffit de cliquer sur la carte bancaire,
                          puis sur “transférer sur un compte bancaire” et de
                          renseigner les informations demandées. L’argent arrive
                          sur votre compte au bout de quelques jours !
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.genral_expanded_7}
                        onChange={() => handleExpanded("genral_expanded_7")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.genral_expanded_7 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,

                              padding: "20px 0px",
                            }}
                          >
                            Y a-t-il une limite de poids pour la livraison des
                            colis ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          Il n’y a pas de limite de poids chez Frank. Pour un
                          déménagement, vous pouvez prévoir le nombre de
                          personnes dont vous avez besoin en renfort en fonction
                          de la taille des meubles.
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                ) : selectedCategory === "Envoyer" ? (
                  <Grid
                    //envoryer faq
                    container
                    spacing={2}
                    style={{
                      padding: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      xs={12}
                      item
                      className="display-flex"
                      style={{
                        flexDirection: "column",
                        padding: "10px",
                        borderRadius: "18px",
                        gap: 20,
                      }}
                    >
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          width: "100%",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_1}
                        onChange={() => handleExpanded("envoyer_expanded_1")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_1 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                            }}
                          >
                            Quels type de colis puis-je envoyer avec Frank ?
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Particuliers ou professionnels, vous pouvez expédier
                            toutes sortes de colis via notre plateforme :
                          </p>
                          <p>
                            1. Des petits paquets : cadeaux, vêtements, livres,
                            etc.{" "}
                          </p>
                          <p>
                            2. Des colis moyens : appareils électroménagers,
                            meubles en kit, vélos, matériel de sport, etc.{" "}
                          </p>
                          <p>
                            3. Des envois volumineux : cartons de déménagement,
                            gros électroménager, meubles, etc
                          </p>
                          <p>
                            Il n'y a pas de limite de poids. Tant qu'un
                            particulier accepte de transporter votre colis !
                            Avec Frank, vous pouvez même organiser votre
                            déménagement !
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_2}
                        onChange={() => handleExpanded("envoyer_expanded_2")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_2 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Où faut-il déposer mon colis ?
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            {" "}
                            Vous convenez d'un point de rendez-vous avec le
                            particulier qui assurera le transport de colis. Cela
                            peut être
                            :ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                          </p>

                          <p> • À votre domicile</p>
                          <p>
                            {" "}
                            • Sur son lieu de départ (gare, aéroport, etc.)
                          </p>

                          <p>
                            L'application vous permet de choisir le lieu le plus
                            pratique et d'échanger avec le transporteur pour
                            organiser la remise du colis en toute simplicité.
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_3}
                        onChange={() => handleExpanded("envoyer_expanded_3")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_3 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Existe-t-il un poids maximum pour l’envoie d’un
                            colis entre particuliers ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Non, il n'y a pas de limite de poids chez Frank,
                            contrairement à de nombreux transporteurs. Notre
                            réseau de particuliers nous permet d'acheminer même
                            les colis les plus lourds et encombrants.
                          </p>
                          <p>
                            C'est idéal pour les déménagements par exemple. Vous
                            pouvez indiquer le volume et le nombre de personnes
                            requises, et constituer une équipe de Frankies pour
                            vous aider !
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_4}
                        onChange={() => handleExpanded("envoyer_expanded_4")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_4 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Puis-je envoyer plusieurs colis en même temps ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Oui, avec Frank vous pouvez grouper vos expéditions
                            sans problème. Au moment de publier votre annonce,
                            précisez simplement le nombre de colis à envoyer en
                            appuyant sur le “ + “. Notre système adapté fera en
                            sorte de trouver le transporteur adéquat, qu'il
                            s'agisse de quelques paquets ou d'une cargaison
                            complète.
                          </p>
                          <p>
                            Vous pouvez aussi envoyer plusieurs colis à
                            plusieurs destinations différentes. Dans ce cas, il
                            faudra publier une annonce par colis.
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_5}
                        onChange={() => handleExpanded("envoyer_expanded_5")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_5 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Quelle assurance est disponible pour mon colis ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Chez Frank, la sécurité de vos colis est notre
                            priorité.C'est pourquoi chaque envoi réalisé via
                            notre service de livraison collaborative est
                            automatiquement assuré à hauteur de 100€, sans frais
                            supplémentaires.
                          </p>
                          <p>
                            Mais si votre colis a une valeur supérieure, pas de
                            panique ! Grâce à notre partenariat avec un assureur
                            indépendant, vous pouvez souscrire à une garantie
                            renforcée qui couvrira intégralement votre bien en
                            cas de vol, casse ou incident pendant le transport.
                          </p>
                          <p>
                            Par ailleurs, notre plateforme collaborative nous
                            permet de sélectionner des livreurs de confiance.
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_6}
                        onChange={() => handleExpanded("envoyer_expanded_6")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_6 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Comment est fixé le prix pour l’envoi de mon colis ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Chez Frank, l’expéditeur peut indiquer le tarif
                            qu’il souhaite pour sa demande de livraison. Le prix
                            dépendra du poids et des dimensions du colis, mais
                            aussi de la distance à parcourir. De leur côté, les
                            transporteurs peuvent être amenés à négocier le
                            prix. Une fois que vous avez renseigné les
                            principales informations concernant votre colis,
                            Frank vous conseille une fourchette de prix que vous
                            pouvez suivre.
                          </p>
                          <p>
                            Nous optimisons chaque trajet pour vous garantir le
                            meilleur rapport qualité-prix, jusqu'à 50 % moins
                            cher que les transporteurs classiques. Avec notre
                            calculateur en ligne, estimez le coût de votre
                            expédition en quelques clics !
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.envoyer_expanded_7}
                        onChange={() => handleExpanded("envoyer_expanded_7")}
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.envoyer_expanded_7 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Quelles sont les zones de livraisons possibles pour
                            l’envoi de mon colis{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Envoyez vos colis partout en France métropolitaine,
                            de la grande ville au petit village. Grâce à notre
                            vaste communauté de transporteurs particuliers, nous
                            couvrons même les zones rurales habituellement mal
                            desservies. Que ce soit pour un trajet local,
                            régional ou national, il y aura toujours un
                            Particulier prêt à livrer votre colis à bon port.
                            Élargissez vos horizons sans vous ruiner !
                          </p>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    //transporter faq
                    container
                    spacing={2}
                    style={{
                      padding: 10,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      xs={12}
                      item
                      className="display-flex"
                      style={{
                        flexDirection: "column",
                        padding: "10px",
                        borderRadius: "18px",
                        gap: 20,
                      }}
                    >
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.transporter_expanded_1}
                        onChange={() =>
                          handleExpanded("transporter_expanded_1")
                        }
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.transporter_expanded_1 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                            }}
                          >
                            Comment suis-je payé avec Frank ?
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Après chaque livraison réussie, vous recevrez votre
                            paiement sur votre porte-monnaie en ligne dans
                            l’application Frank.Vous pourrez par la suite verser
                            le montant collecté directement sur votre compte
                            bancaire, sans frais supplémentaires. Vous pouvez
                            également utiliser votre cagnotte sur la marketplace
                            Frank.
                          </p>
                          <p>
                            Il était essentiel pour nous de proposer un
                            processus simple et rapide, pour permettre à nos
                            livreurs d'accéder facilement à leur rémunération.
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.transporter_expanded_2}
                        onChange={() =>
                          handleExpanded("transporter_expanded_2")
                        }
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.transporter_expanded_2 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Comment est déterminé le prix d’une livraison ?
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Le prix d’une livraison est déterminé par
                            l’expéditeur du colis et indiqué au sein de
                            l’annonce proposée. Le transporteur peut négocier le
                            prix qui figure sur l’annonce pour trouver un accord
                            sur le montant avec l’expéditeur.
                          </p>
                          <p>
                            Notre objectif : proposer des tarifs justes et
                            compétitifs pour le transport routier, tant pour les
                            cotransporteurs que pour les clients expéditeurs
                          </p>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.transporter_expanded_3}
                        onChange={() =>
                          handleExpanded("transporter_expanded_3")
                        }
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.transporter_expanded_3 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Devenir transporteur est-il un travail à temps plein
                            ?
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Non, devenir cotransporteur avec Frank ne nécessite
                            pas forcément un engagement à temps plein.Vous êtes
                            libre de choisir le nombre et la fréquence des
                            missions que vous souhaitez effectuer, en fonction
                            de vos disponibilités et de vos objectifs. Que vous
                            soyez étudiant, salarié ou indépendant, vous pouvez
                            adapter votre activité de transporteur à votre
                            emploi du temps.
                          </p>
                          <p>
                            Par ailleurs, sachez qu'en effectuant des missions
                            avec Frank, vous n'exercez pas le métier de
                            transporteur de marchandises comme le ferait un
                            livreur pour une entreprise de transport. Vous
                            n'avez donc pas besoin d'une licence de transport.
                            Les compétences nécessaires sont aussi accessibles à
                            tous.
                          </p>
                        </AccordionDetails>
                      </Accordion>
                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.transporter_expanded_4}
                        onChange={() =>
                          handleExpanded("transporter_expanded_4")
                        }
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.transporter_expanded_4 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Quels types de colis sont livrés ?{" "}
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            En tant que cotransporteur Frank, vous pouvez être
                            amené à livrer une grande variété de colis et de
                            marchandises, tels que :ㅤㅤㅤㅤㅤㅤ
                          </p>
                          <p>• Des documents</p>
                          <p>• Des petits objets et cadeaux</p>{" "}
                          <p>• Des produits électroniques</p>
                          <p>• Des vêtements et accessoires</p>{" "}
                          <p>• Des produits alimentaires non périssables</p>
                          <p>
                            Chaque annonce de livraison indique clairement
                            toutes les conditions préalables au transport de la
                            marchandise : la nature du colis à transporter,
                            ainsi que ses dimensions et son poids, vous
                            permettant ainsi de choisir les missions qui vous
                            conviennent le mieux. Les prestations de transport
                            sont donc détaillées, pour que vous puissiez faire
                            un choix éclairé lors de la sélection de vos
                            missions.
                          </p>
                        </AccordionDetails>
                      </Accordion>

                      <Accordion
                        elevation={0}
                        style={{
                          border: "0px",
                          background: "#FFFF",
                        }}
                        expanded={state?.transporter_expanded_5}
                        onChange={() =>
                          handleExpanded("transporter_expanded_5")
                        }
                      >
                        <AccordionSummary
                          style={{ border: "none", marginTop: 20 }}
                          // expandIcon={<AddIcon />}
                          expandIcon={
                            state?.transporter_expanded_5 ? (
                              <RemoveIcon
                                style={{
                                  color: defaultLabelColors.main_orange_new,
                                }}
                              />
                            ) : (
                              <AddIcon />
                            )
                          } // Dynamic icon change
                          className="faq-comments"
                          sx={{
                            "&.Mui-expanded h3": {
                              color: defaultLabelColors?.main_orange_new,
                            }, // Change h3 color when expanded
                          }}
                        >
                          <h3
                            style={{
                              fontWeight: "500",
                              fontFamily: "montserrat-Medium",
                              fontSize: screen_1024 ? 22 : 18,
                              padding: "20px 0px",
                            }}
                          >
                            Si j’annule une course, est ce que je suis pénalisé
                          </h3>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            width: "90%",
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: screen_1024 ? 18 : 14,
                          }}
                        >
                          <p>
                            Bien que nous encouragions nos cotransporteurs à
                            honorer leurs engagements, nous comprenons que des
                            imprévus puissent survenir. En cas d'annulation de
                            votre part, veillez à prévenir Frank et le client
                            expéditeur dans les meilleurs délais. Si vos
                            annulations restent exceptionnelles, vous ne serez
                            pas pénalisé.
                          </p>
                          <p>
                            Cependant, des annulations fréquentes ou de dernière
                            minute peuvent entraîner une baisse de votre note de
                            confiance et une réduction du nombre de missions qui
                            vous sont proposées. Il s'agit pour Frank de
                            garantir aux utilisateurs une bonne qualité de
                            service.
                          </p>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div
          className="main-container"
          style={{
            background: defaultLabelColors?.main_background_new,
            zIndex: 1,
          }}
        >
          <CustomFooter showBorder={true} />
        </div> */}
        {screen_1024 ? (
          <div className="main-container"
          style={{
            background: defaultLabelColors?.main_background_new,
            zIndex: 1,
          }}
          >
            <CustomFooter />
          </div>
        ) : screen_600 ? (
          <CustomMobileFooter />
        ) : null}
      </div>
      <div className="mobile-screen"><MobileResponsive/></div>
     
    </>
  );
}

export default FAQ;
